<div class="full-container pt-5 lg:pr-5 lg:pl-5 w-full pb-6">
  <section class="flex justify-content-between pb-5 align-items-center px-3 lg:px-0 orders-header">
    <div>
      <h1 class="text-2xl mx-0 my-0 title">{{ 'orders.title' | translate }}</h1>
      <p class="mx-0 my-0 subtitle">{{ 'orders.subtitle' | translate }}</p>
    </div>
  </section>
  <section class="w-full max-w-screen">
    <p-tabs [value]="activeTabIndex" (onTabChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">{{ 'orders.sent' | translate }}</p-tab>
        <p-tab [value]="1">{{ 'orders.canceled' | translate }}</p-tab>
        <p-tab [value]="2">{{ 'orders.archival' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <rqa-sent-orders></rqa-sent-orders>
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <rqa-canceled-orders></rqa-canceled-orders>
        </p-tabpanel>
        <p-tabpanel [value]="2">
          <rqa-archival-orders></rqa-archival-orders>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </section>
</div>
